import RegualmentoContainer from './regulamento.container'

export default RegualmentoContainer
